module.exports = __webpack_public_path__ + "static/media/TrendLogoWhite.f066ffdb.svg";